import React from 'react';
import numeral from 'numeral';

const MapTooltip = ({ objectToDisplay, pointerX, pointerY }) => {
  console.log(objectToDisplay);
  let valueToDisplay = 0;
  let numberOfPoints = 0;
  objectToDisplay.points.forEach((point) => {
    valueToDisplay += point.avg_3_month_revenue
    numberOfPoints += 1;
  });
  return (
    <div style={{ position: 'absolute', zIndex: 3, pointerEvents: 'none', left: pointerX + 20, top: pointerY, ...styles.tooltipContainer }}>
      <span style={styles.description}>Số điểm: {numberOfPoints}</span><br />
      <span style={styles.description}>Nhu cầu trung bình: {numeral(valueToDisplay / numberOfPoints).format('0,0')} VND (tỉ lệ)</span>
    </div>
  );
}

const styles = {
  tooltipContainer: {
    backgroundColor: 'var(--color-white)',
    padding: 12,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,.24)',
    borderRadius: 4,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  description: {
    fontSize: 14,
    whiteSpace: 'pre-line',
  }
}

export default MapTooltip;